import tvIcon from '@/assets/images/tv.svg'
import tvBlueIcon from '@/assets/images/tv-blue.svg'
import onlineIcon from '@/assets/images/online.svg'
import onlineBlueIcon from '@/assets/images/online-blue.svg'
import totalIcon from '@/assets/images/total.svg'
import totalBlueIcon from '@/assets/images/total-blue.svg'
import videoInHomeIcon from '@/assets/images/video-in-home.svg'
import videoInHomeBlueIcon from '@/assets/images/video-in-home-blue.svg'
import portalIcon from '@/assets/images/portal.svg'
import portalBlueIcon from '@/assets/images/portal-blue.svg'

export default [
  {
    id: "broadcast",
    title: "BROADCAST",
    subtitle: "TV screens live & catch-up in-home",
    iconSrc: tvIcon,
    iconSrcBlue: tvBlueIcon,
    configLinkKey: "config_LinkTvAnalys",
    infoCardType: "AppInfoCard",
    analysisType:
      "Analyze TV channels audiences for specific dayparts, programs, series or advertising campaigns.",
    datasetScope:
      "Only content and ads broadcasted on TV channels. Refers to viewing on TV screens regardless of distribution form, up to 7 days after air date. Consumption in home only.",
    granularity:
      "Minute-by-minute data or individual programs & ads. Demographics include age and gender.",
    capabilities: ["info", "target", "search", "home", "tv"],
    popupVisible: false,
    showInfoIcon: false,
    userAccess: false
  },
  {
    id: "online-video",
    title: "ONLINE VIDEO",
    subtitle: "All screens",
    iconSrc: onlineIcon,
    iconSrcBlue: onlineBlueIcon,
    configLinkKey: "config_LinkOnlineAnalys",
    infoCardType: "AppInfoCard",
    analysisType:
      "Analyze Online Video audiences for specific programs, series or advertising campaigns.",
    datasetScope:
      "Only content and ads published on streaming services for participating media companies. Refers to consumption via digital devices on all screens. Consumption in and out-of-home.",
    granularity:
      "Individual programs and ads aggregated per media company on a daily level. Demographics include age and gender.",
    capabilities: ["info", "target", "search", "home", "away", "tv", "devices"],
    popupVisible: false,
    showInfoIcon: false,
    userAccess: false
  },
  {
    id: "cross-platform",
    title: "CROSS-PLATFORM",
    subtitle: "All screens",
    iconSrc: totalIcon,
    iconSrcBlue: totalBlueIcon,
    configLinkKey: "config_LinkTotalanalys",
    infoCardType: "AppInfoCard",
    analysisType:
      "Analyze unduplicated cross-platform audience for specific programs, series or advertising campaigns.",
    datasetScope:
      "Content and ads broadcasted or published on channels and streaming services for participating media companies. Refers to unduplicated viewing on all screens. Consumption in and out-of-home.",
    granularity:
      "Individual programs and ads aggregated by media company on a daily level. Demographics include age and gender.",
    capabilities: ["info", "target", "search", "home", "away", "tv", "devices"],
    popupVisible: false,
    showInfoIcon: false,
    userAccess: false
  },
  {
    id: "video-in-home",
    title: "VIDEO IN HOME",
    subtitle: "All screens in-home",
    iconSrc: videoInHomeIcon,
    iconSrcBlue: videoInHomeBlueIcon,
    configLinkKey: "config_LinkVideoInHome",
    infoCardType: "AppInfoCard",
    analysisType:
      "Analyze total in home audiences (channels and streaming services combined) for specific dayparts.",
    datasetScope:
      "Both consumption of broadcasted TV channels and streaming services. Refers to streaming on all screens, via home internet networks only. Consumption in home only.",
    granularity:
      "Minute-by-minute data aggregated per media owner. Demographics include age and gender.",
    capabilities: ["info", "target", "search", "home", "tv", "devices"],
    popupVisible: false,
    showInfoIcon: false,
    userAccess: false
  },
  {
    id: "portal",
    title: "PORTAL",
    subtitle: "Current & historic datasets",
    iconSrc: portalIcon,
    iconSrcBlue: portalBlueIcon,
    configLinkKey: "config_LinkDataPortal",
    infoCardType: "PortalInfoCard",
    analysisType: "Central repository for all MMS applications.",
    datasetScope: "",
    granularity: "",
    capabilities: ["info"],
    popupVisible: false,
    showInfoIcon: false,
    userAccess: true
  }
];
